import api from "../../services/api";
import type { GetStandingsResponse } from "./types";

export const standingsApi = {
  getStandingsByFormat: async (formatId: string, live: boolean = false): Promise<GetStandingsResponse> => {
    return api.get(`/standings/format/${formatId}`, { params: { live } });
  },
};


